import make_translations from "@pdfking/workflow/utils/make_translations"
import { defineComponent } from "vue"

export default defineComponent({
  computed: {
    translations: () => make_translations("errors"),
  },
  props: [] as const,
  render() {
    return (
      <div class="alert alert-danger m-0">
        {this.translations.errors.BROWSER_ERROR}
      </div>
    )
  },
})
